import type { LocalizedString } from '@/services/dto';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
    categoryOnFloor?: LocalizedString;
    tabIndex?: number;
};

export const HorizontalMapHeader = ({ categoryOnFloor, tabIndex }: Props) => {
    const { t, i18n } = useTranslation();

    const displayText = useMemo(() => {
        if (!categoryOnFloor) {
            return '';
        }
        return categoryOnFloor[i18n.language] ?? '';
    }, [categoryOnFloor, i18n]);
    return (
        <section className="bg-not-contrast-white contrast:bg-not-contrast-black text-center" data-region-nav data-region-order={2}>
            <p
                tabIndex={tabIndex}
                data-interactive
                aria-label={displayText}
                className="text-text-main01 focus-border  h-[calc-(116*var(--vh-unit))] pt-[calc(56*var(--vh-unit))] pb-[calc(36*var(--vh-unit))] text-[calc(28*var(--vh-unit))] leading-[calc(24*var(--vh-unit))]"
            >
                {displayText || <span>&nbsp;</span>}
            </p>
            <p className="text-not-contrast-gray-999 py-[calc(8*var(--vh-unit))] text-[calc(18*var(--vh-unit))] leading-[calc(24*var(--vh-unit))]">
                {t('floor_guide.message.you_can_you_multi_touch')}
            </p>
        </section>
    );
};
